import { TZDate } from '@date-fns/tz';
import { NoddiButton, NoddiDialog } from 'noddi-ui-web';
import { CustomDateFormats, noddiFormatDate } from 'noddi-util';

type Props = {
  open: boolean;
  onClose: () => void;
  reason: string | null;
  firstAvailableDate: TZDate;
  translations: {
    earliestDeliveryDialogTitle: string;
    earliestDeliveryDialogMessage: string;
    earliestAvailableDate: string;
    earliestDeliveryReasons: {
      wheel_storage_inventory_lead_time: string;
      wheel_pickup_at_other_address_lead_time: string;
      default: string;
    };
  };
};

export const EarliestDeliveryDialog = ({ open, onClose, reason, firstAvailableDate, translations }: Props) => {
  const getReasonMessage = () => {
    if (!reason) {
      return null;
    }

    // Check if we have a specific translation for this reason code
    if (reason in translations.earliestDeliveryReasons) {
      return translations.earliestDeliveryReasons[reason as keyof typeof translations.earliestDeliveryReasons];
    }

    // Fall back to default message
    return translations.earliestDeliveryReasons.default;
  };

  const formattedDate = noddiFormatDate(firstAvailableDate, CustomDateFormats.FULL_DAY_MONTH);
  const reasonMessage = getReasonMessage();

  const { earliestAvailableDate, earliestDeliveryDialogMessage, earliestDeliveryDialogTitle } = translations;
  return (
    <NoddiDialog
      title={earliestDeliveryDialogTitle}
      description={earliestDeliveryDialogMessage}
      onClose={onClose}
      open={open}
      footer={
        <NoddiButton onClick={onClose} variant='primary' className='w-full'>
          OK
        </NoddiButton>
      }
    >
      <div className='flex flex-col gap-4'>
        <div className='rounded-lg border p-4'>
          <p className='text-sm'>{earliestAvailableDate}</p>
          <p className='font-semibold'>{formattedDate}</p>
        </div>
        {reasonMessage && <p>{reasonMessage}</p>}
      </div>
    </NoddiDialog>
  );
};
